import './header.scss';

import React from 'react';
import Authentication from '../../authentication';
import { NavLink } from 'react-router-dom';

export default class extends React.Component {

  state = {
    round: 0
  };

  componentDidMount() {
    this.unregister = Authentication.onAuthenticationChange(() => {
      return new Promise((resolve) => this.setState((state) => ({
        round: state.round + 1
      }), resolve));
    });
  }

  componentWillUnmount() {
    if (this.unregister instanceof Function) {
      this.unregister();
      this.unregister = null;
    }
  }

  render() {
    return (
      <header className="header">
        <NavLink to="/" className="brand" activeClassName="brand-active"><i className="fa fa-smile-o" /><i className="fa fa-meh-o" />&nbsp;Reviews</NavLink>
        {
          Authentication.isAuthenticated() ? (
            <ul className="menu-list">
              <li className="menu-item">
                <NavLink to="/invitations" className="menu-link" activeClassName="menu-link-active">
                  Invitations
                </NavLink>
              </li>
              <li className="menu-item">
                <NavLink to="/feedback" className="menu-link" activeClassName="menu-link-active">
                  Feedback
                </NavLink>
              </li>
              <li className="menu-item">
                <NavLink to="/settings" className="menu-link" activeClassName="menu-link-active">
                  Settings
                </NavLink>
              </li>
              <li className="menu-item">
                <span className="menu-link" onClick={Authentication.unauthenticate.bind(Authentication)}>
                  Logout
                </span>
              </li>
            </ul>
          ) : null
        }
      </header>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/header/index.js